// O nome da plataforma é "AppStock" — sem "AI" colado. O "AI" vive na tagline
// ("AI Sales Platform") e no sparkle teal da marca; repeti-lo no nome era
// redundante. Não reintroduzir "AppStock AI" em nenhum destes campos.
export const BRANDING = {
  appName: "AppStock",
  /** Wordmark exibido no logo (a linha "AI Sales Platform" vem em appTagline). */
  appWordmark: "AppStock",
  appTagline: "AI Sales Platform",
  appTitle: "AppStock | AI Sales Platform",
  appDescription: "AI Sales Platform for Stone Industry.",
  companyName: "AppStock",
  logoAlt: "AppStock — AI Sales Platform",
  themeColor: "#3F6F9F",
} as const;

export type BrandingConfig = typeof BRANDING;
